import { onUnmounted, shallowRef } from "vue";

export interface PageTitleAction {
  label: string;
  outline?: boolean;
  // Rendered left of the label.
  icon?: string;
  dataTest?: string;
  onClick: () => void;
}

// shallowRef keeps the registered array identity intact, so the unmount guard
// below can compare it against what the page registered.
const actions = shallowRef<PageTitleAction[]>([]);

export const pageTitleActions = actions;

/**
 * Registers actions that MainLayout renders next to the page title. The layout
 * owns the markup, so a page never teleports into layout-owned DOM (which
 * crashes once the layout removes the title row on navigation).
 */
export const usePageTitleActions = (pageActions: PageTitleAction[]): void => {
  actions.value = pageActions;

  onUnmounted(() => {
    // The next page mounts (and registers its own actions) before this runs, so
    // only clear when our actions are still the registered ones.
    if (actions.value === pageActions) {
      actions.value = [];
    }
  });
};
